var _sodipodiNamedview, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _colorProfile, _path2, _path3, _feColorMatrix, _feColorMatrix2, _feColorMatrix3, _feColorMatrix4, _feColorMatrix5, _feColorMatrix6, _feColorMatrix7, _feColorMatrix8, _feColorMatrix9, _feColorMatrix10, _feColorMatrix11, _feColorMatrix12, _clipPath, _defs, _clipPath2, _defs2, _clipPath3, _defs3, _clipPath4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 99.270272 99.270279",
    id: "svg203",
    sodipodidocname: "logo_bw.svg",
    width: 99.270279,
    height: 99.270279,
    inkscapeversion: "1.1 (c68e22c387, 2021-05-23)",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview205",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    showgrid: "false",
    width: "812.90002px",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    units: "in",
    inkscapezoom: 2.0998893,
    inkscapecx: 10.714851,
    inkscapecy: 87.861775,
    "inkscapewindow-width": 1920,
    "inkscapewindow-height": 1013,
    "inkscapewindow-x": -9,
    "inkscapewindow-y": -9,
    "inkscapewindow-maximized": 1,
    "inkscapecurrent-layer": "svg203"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 33.675999,
    y1: 134.05499,
    x2: 30.82,
    y2: -520.57501,
    gradientTransform: "translate(-0.00516161,-0.12456398)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e53516",
    id: "stop108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffd405",
    id: "stop110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e21318",
    id: "stop112"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 51.694838,66.675436 c -0.7,0.1 -1.3,0.1 -2,0.1 -0.7,0 -1.3,0 -2,-0.1 -18.8,-1 -33.3,-17.2 -32.2,-36 0.2,-4.2 1.2,-8.3 2.9,-12.1 0.8,-1.7 1.7,-3.3 2.7,-4.9 2.8,-4.2 6.5,-7.8 10.8,-10.4 -25.5999996,9.8 -38.3999996,38.5 -28.5999996,64.1 1.1,1.9 2.4,3.6 3.8,5.2 10.8999996,12.1 28.6999996,14.9 42.6999996,6.7 2,-1.2 3.9,-2.6 5.6,-4.1 3.6,-3.2 6.4,-7.1 8.4,-11.5 1.7,-3.8 2.7,-7.9 2.9,-12 -1,7.8 -7.2,14 -15,15 z",
    fill: "url(#A)",
    id: "path115",
    style: {
      fill: "#1c1c24",
      fillRule: "evenodd",
      filter: "url(#filter3366)"
    }
  }), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 56.084999,
    y1: 120.967,
    x2: 55.131001,
    y2: -97.553001,
    gradientTransform: "translate(-0.00516161,-0.12456398)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e64415",
    id: "stop117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffd405",
    id: "stop119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e21318",
    id: "stop121"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 66.994838,3.175436 c -11.4,-4.3 -23.8,-4.2 -35.1,0.1 -4.4,2.7 -8.1,6.2 -10.9,10.5 -1,1.6 -1.9,3.2 -2.6,4.9 -7.7,17.2 0,37.4 17.3,45.2 3.8,1.7 7.9,2.7 12.1,2.9 -7.9,-0.9 -14.2,-7.1 -15.1,-15 -0.1,-0.7 -0.1,-1.3 -0.1,-2 0,-0.7 0,-1.3 0.1,-2 1,-18.8 17.2,-33.3 36,-32.2 4.2,0.2 8.2,1.2 12,2.9 1.7,0.8 3.3,1.6 4.9,2.7 4.3,2.8 7.8,6.5 10.5,10.8 -5.2,-13.4 -15.8,-23.8 -29.1,-28.8 z",
    fill: "url(#B)",
    id: "path124",
    style: {
      fill: "#dbdbe3",
      fillRule: "evenodd",
      filter: "url(#filter3370)"
    }
  }), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 3.891,
    y1: 43.479,
    x2: 202.81,
    y2: 81.412003,
    gradientTransform: "translate(-0.00516161,-0.12456398)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e32618",
    id: "stop126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffd405",
    id: "stop128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e21318",
    id: "stop130"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 95.994838,31.875436 c -2.6,-4.4 -6.2,-8.1 -10.5,-10.8 -1.5,-1 -3.2,-1.9 -4.9,-2.7 -15.3,-6.8 -33.3,-1.6 -42.5,12.4 -3.3,5.1 -5.3,10.9 -5.6,17 1,-8.6 8.3,-15.1 17,-15.3 0.7,0 1.4,0.1 2.1,0.1 9,0.5 17.5,4.5 23.5,11.3 1.6,1.7 2.9,3.6 4.1,5.6 8.2,14 5.4,31.8 -6.7,42.7 -1.6,1.4 -3.4,2.7 -5.2,3.9 13.3,-5.1 23.8,-15.7 28.8,-29 4.300002,-11.4 4.200002,-23.9 -0.1,-35.2 z",
    fill: "url(#C)",
    id: "path133",
    style: {
      fill: "#9393ac",
      fillRule: "evenodd",
      filter: "url(#filter3374)"
    }
  }), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 43.882999,
    y1: 136.94,
    x2: 42.924999,
    y2: -82.68,
    gradientTransform: "translate(-0.00516161,-0.12456398)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#eb660c",
    id: "stop135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ffd405",
    id: "stop137"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 79.294838,49.475436 c -3.6,-6.2 -9.1,-11.1 -15.6,-14 -3.8,-1.7 -7.9,-2.7 -12,-2.9 8.6,1.1 15.1,8.3 15.2,17 0,0.7 0,1.3 -0.1,2 -0.2,4.1 -1.2,8.2 -2.9,12 -2,4.4 -4.8,8.3 -8.4,11.6 -1.7,1.6 -3.6,2.9 -5.6,4.1 -14,8.2 -31.8,5.4 -42.6999996,-6.7 -1.4,-1.6 -2.7,-3.3 -3.8,-5.2 9.7999996,25.6 38.4999996,38.400004 64.0999996,28.6 1.8,-1.1 3.6,-2.4 5.2,-3.8 11.9,-10.8 14.7,-28.7 6.6,-42.7 z",
    fill: "url(#D)",
    id: "path140",
    style: {
      fill: "#373748",
      fillRule: "evenodd",
      filter: "url(#filter3378)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 147.29484,56.075436 h -10 v 19.5 h -10.1 v -51.8 h 20.1 c 10.7,0 17.1,7.4 17.1,16.2 0,8.8 -6.4,16.1 -17.1,16.1 z m -0.6,-23.3 h -9.5 v 14.2 h 9.5 c 4.6,0 7.5,-2.8 7.5,-7.1 0,-4.3 -2.8,-7.1 -7.5,-7.1 z m 51.9,42.9 v -21.8 h -17.6 v 21.7 h -10.1 v -51.8 h 10.1 v 21.2 h 17.6 v -21.2 h 10.1 v 51.9 z m 51.4,-5.3 c -3.7,3.8 -8.7,5.8 -14,5.7 -5.3,0.2 -10.4,-1.9 -14.1,-5.7 -5.2,-5.3 -5.1,-11.7 -5.1,-20.7 0,-9 -0.1,-15.5 5.1,-20.7 3.7,-3.8 8.8,-5.8 14.1,-5.7 5.3,-0.2 10.3,1.9 14,5.7 5.3,5.2 5.2,11.7 5.2,20.7 0,9 0.1,15.5 -5.2,20.7 z m -7.5,-35.3 c -1.6,-1.8 -4,-2.8 -6.5,-2.8 a 8.36,8.36 0 0 0 -6.6,2.8 c -2,2.2 -2.5,4.6 -2.5,14.6 0,10 0.5,12.4 2.5,14.6 1.7,1.8 4.1,2.8 6.6,2.8 2.5,0.1 4.8,-0.9 6.5,-2.8 2,-2.2 2.6,-4.6 2.6,-14.6 0,-10 -0.6,-12.4 -2.6,-14.6 z m 41,-2.3 v 42.9 h -10.1 v -42.9 h -13.6 v -9 h 37.2 v 9 z m 50.8,37.6 c -3.7,3.8 -8.7,5.8 -14,5.7 -5.3,0.2 -10.4,-1.9 -14.1,-5.7 -5.2,-5.3 -5.1,-11.7 -5.1,-20.7 0,-9 -0.1,-15.5 5.1,-20.7 3.7,-3.8 8.8,-5.9 14.1,-5.7 5.3,-0.2 10.3,1.9 14,5.7 5.3,5.2 5.2,11.7 5.2,20.7 0,9 0.1,15.5 -5.2,20.7 z m -7.5,-35.3 c -1.6,-1.8 -4,-2.8 -6.4,-2.8 a 8.36,8.36 0 0 0 -6.6,2.8 c -2,2.2 -2.5,4.6 -2.5,14.6 0,10 0.5,12.4 2.5,14.6 1.7,1.8 4.1,2.8 6.6,2.8 2.5,0.1 4.8,-0.9 6.5,-2.8 2,-2.2 2.5,-4.6 2.5,-14.6 0,-10 -0.6,-12.4 -2.6,-14.6 z m 36.4,41 c -7.8,0 -12.9,-2 -17.8,-6.9 l 3.8,-3.8 c 4.3,4.3 8.3,5.7 14.1,5.7 7.6,0 12.3,-3.6 12.3,-9.6 a 8.03,8.03 0 0 0 -2.5,-6.5 c -1.7,-1.4 -3,-1.9 -6.8,-2.5 l -6,-1 c -4.1,-0.7 -7.3,-2 -9.6,-3.9 -2.6,-2.3 -3.9,-5.5 -3.9,-9.7 0,-8.8 6.3,-14.7 16.6,-14.7 6.6,0 11,1.7 15.5,5.7 l -3.6,3.6 c -3.2,-2.9 -6.6,-4.4 -12.1,-4.4 -6.9,0 -10.9,3.9 -10.9,9.6 -0.2,2.2 0.7,4.5 2.3,6 a 14.82,14.82 0 0 0 7,2.8 l 5.7,0.9 c 4.9,0.7 7.3,1.8 9.5,3.7 2.9,2.6 4.5,6.4 4.4,10.3 -0.1,9.1 -7.2,14.7 -18,14.7 z m 43.4,-21.8 h -13.8 v 21.4 h -5.5 v -51.9 h 19.3 c 9.5,0 16,5.9 16,15.2 0,9.3 -6.5,15.3 -16,15.3 z m -0.5,-25.6 h -13.3 v 20.6 h 13.3 c 6.5,0 11,-3.5 11,-10.4 0,-6.9 -4.5,-10.2 -11,-10.2 z m 23.5,47 v -51.9 h 32.2 v 5 h -26.7 v 18.3 h 22.8 v 5 h -22.8 v 18.7 h 26.7 v 5 z m 56.4,0.4 c -5,0.1 -9.8,-1.9 -13.3,-5.4 -4.9,-4.9 -4.9,-10 -4.9,-21 0,-11 0,-16.1 4.9,-21 3.5,-3.5 8.3,-5.5 13.3,-5.4 9.3,0 16.3,5.7 18,15.5 h -5.7 c -1.4,-6.3 -5.8,-10.5 -12.3,-10.5 -3.4,0 -6.6,1.3 -9,3.6 -3.3,3.3 -3.6,6.9 -3.6,17.8 0,10.9 0.4,14.4 3.6,17.8 2.4,2.4 5.6,3.7 9,3.7 6.5,0 11.1,-4.2 12.5,-10.5 h 5.5 c -1.7,9.7 -8.8,15.4 -18,15.4 z m 27.7,-0.4 v -51.9 h 5.5 v 51.9 z m 46.6,0 -4.1,-11.8 h -22.7 l -4.1,11.7 h -5.9 l 19.1,-51.9 h 4.7 l 19,51.9 z m -15.4,-44 -9.8,27.4 h 19.4 z m 25.6,44 v -51.9 h 5.5 v 47 h 26.5 v 5 z m 38.2,0 v -51.9 h 5.5 v 51.9 z m 31.4,0.4 c -7.8,0 -12.9,-2 -17.8,-6.9 l 3.8,-3.8 c 4.3,4.3 8.3,5.7 14.1,5.7 7.6,0 12.3,-3.6 12.3,-9.6 a 8.03,8.03 0 0 0 -2.5,-6.5 c -1.7,-1.4 -3,-1.9 -6.8,-2.5 l -6,-1 c -4.1,-0.7 -7.3,-2 -9.5,-3.9 -2.6,-2.3 -3.9,-5.5 -3.9,-9.7 0,-8.8 6.3,-14.7 16.6,-14.7 6.6,0 11,1.7 15.5,5.7 l -3.6,3.6 c -3.2,-2.9 -6.6,-4.4 -12.1,-4.4 -6.9,0 -10.9,3.9 -10.9,9.6 -0.2,2.2 0.7,4.5 2.3,6 a 14.82,14.82 0 0 0 7,2.8 l 5.7,0.9 c 4.9,0.7 7.3,1.8 9.5,3.7 2.9,2.6 4.5,6.4 4.4,10.3 -0.2,9.1 -7.3,14.7 -18.1,14.7 z m 42.4,-47.4 v 47 h -5.5 v -47 h -15 v -5 h 35.6 v 5 z m -105.5,65.7 v 4.9 h -2.6 v -13.9 h 4.5 c 0.8,0 1.6,0.1 2.4,0.3 0.6,0.2 1.2,0.5 1.7,0.9 0.4,0.4 0.8,0.9 1,1.4 0.2,0.6 0.3,1.2 0.3,1.8 0,0.6 -0.1,1.2 -0.3,1.8 -0.2,0.6 -0.6,1 -1,1.4 -0.5,0.4 -1.1,0.7 -1.7,0.9 -0.8,0.2 -1.6,0.4 -2.3,0.3 h -2 z m 0,-2 h 1.9 c 0.4,0 0.8,0 1.2,-0.2 0.3,-0.1 0.6,-0.3 0.9,-0.5 0.2,-0.2 0.4,-0.5 0.5,-0.8 0.1,-0.3 0.2,-0.7 0.2,-1 0,-0.3 -0.1,-0.7 -0.2,-1 -0.1,-0.3 -0.3,-0.5 -0.5,-0.8 -0.3,-0.2 -0.5,-0.4 -0.9,-0.5 -0.4,-0.1 -0.8,-0.2 -1.2,-0.2 h -1.9 z m 22.5,-0.1 c 0,1 -0.2,1.9 -0.5,2.8 -0.6,1.7 -1.9,3 -3.6,3.7 a 8,8 0 0 1 -5.7,0 c -1.7,-0.7 -3,-2 -3.6,-3.7 a 7.73,7.73 0 0 1 0,-5.6 c 0.3,-0.8 0.8,-1.6 1.4,-2.2 0.6,-0.6 1.4,-1.1 2.2,-1.5 a 8,8 0 0 1 5.7,0 c 1.7,0.7 3,2 3.6,3.7 0.3,0.9 0.5,1.9 0.5,2.8 z m -2.7,0 c 0,-0.7 -0.1,-1.4 -0.3,-2 -0.2,-0.6 -0.5,-1.1 -0.9,-1.5 -0.4,-0.4 -0.8,-0.8 -1.4,-1 -0.6,-0.2 -1.2,-0.3 -1.8,-0.3 -0.6,0 -1.2,0.1 -1.8,0.3 -0.5,0.2 -1,0.6 -1.4,1 -0.4,0.4 -0.7,1 -0.9,1.5 -0.4,1.3 -0.4,2.7 0,4.1 0.2,0.6 0.5,1.1 0.9,1.5 0.4,0.4 0.9,0.8 1.4,1 0.6,0.2 1.2,0.3 1.8,0.3 0.6,0 1.2,-0.1 1.8,-0.3 0.5,-0.2 1,-0.6 1.4,-1 0.4,-0.4 0.7,-1 0.9,-1.5 0.2,-0.7 0.3,-1.4 0.3,-2.1 z m 3.4,-6.9 h 2.2 c 0.2,0 0.4,0 0.6,0.2 0.1,0.1 0.3,0.2 0.3,0.4 l 2.3,8.3 c 0.1,0.2 0.1,0.4 0.2,0.7 0.1,0.3 0.1,0.5 0.1,0.8 0,-0.3 0.1,-0.5 0.2,-0.8 0.1,-0.3 0.1,-0.5 0.2,-0.7 l 2.7,-8.3 c 0.1,-0.2 0.2,-0.3 0.3,-0.4 0.2,-0.1 0.4,-0.2 0.5,-0.2 h 0.8 c 0.2,0 0.4,0 0.6,0.2 0.1,0.1 0.3,0.2 0.3,0.4 l 2.7,8.3 0.4,1.4 c 0,-0.3 0.1,-0.5 0.1,-0.7 0,-0.2 0.1,-0.4 0.2,-0.6 l 2.3,-8.3 c 0,-0.2 0.1,-0.3 0.3,-0.4 0.2,-0.1 0.4,-0.2 0.6,-0.2 h 2 l -4.3,13.8 h -2.3 l -3,-9.4 c 0,-0.1 -0.1,-0.3 -0.1,-0.4 -0.1,-0.1 -0.1,-0.3 -0.1,-0.4 l -0.1,0.4 c 0,0.1 -0.1,0.3 -0.1,0.4 l -3,9.4 h -2.3 z m 30,0 v 2 h -6.2 v 3.8 h 4.8 v 2 h -4.8 v 3.9 h 6.1 v 2.1 h -8.7 v -13.8 z m 4.8,8.4 v 5.4 h -2.6 v -13.8 h 4.2 c 0.8,0 1.6,0.1 2.4,0.3 0.6,0.2 1.2,0.4 1.7,0.8 0.4,0.3 0.7,0.8 1,1.3 a 4.53,4.53 0 0 1 0.3,1.6 c 0,0.4 -0.1,0.9 -0.2,1.3 -0.1,0.4 -0.3,0.8 -0.6,1.1 -0.3,0.3 -0.6,0.6 -1,0.9 -0.4,0.3 -0.8,0.5 -1.3,0.6 0.3,0.2 0.6,0.5 0.8,0.8 l 3.5,5.1 h -2.3 c -0.2,0 -0.4,0 -0.6,-0.1 a 0.78,0.78 0 0 1 -0.4,-0.4 l -2.9,-4.4 c -0.1,-0.1 -0.2,-0.3 -0.3,-0.4 -0.2,-0.1 -0.4,-0.1 -0.6,-0.1 z m 0,-1.8 h 1.6 c 0.4,0 0.9,-0.1 1.3,-0.2 0.3,-0.1 0.6,-0.3 0.9,-0.5 0.2,-0.2 0.4,-0.5 0.5,-0.8 0.1,-0.3 0.2,-0.7 0.2,-1 0,-0.6 -0.2,-1.2 -0.7,-1.6 -0.6,-0.4 -1.4,-0.6 -2.1,-0.6 h -1.7 z m 18.6,-6.6 v 2 h -6.1 v 3.8 h 4.8 v 2 h -4.8 v 3.9 h 6.1 v 2.1 h -8.7 v -13.8 z m 14.4,6.9 c 0,1 -0.2,1.9 -0.5,2.8 -0.3,0.8 -0.8,1.6 -1.4,2.2 -0.6,0.6 -1.4,1.1 -2.2,1.4 -0.9,0.3 -1.9,0.5 -2.8,0.5 h -5.3 v -13.8 h 5.3 c 1,0 1.9,0.2 2.8,0.5 0.8,0.3 1.6,0.8 2.2,1.4 0.6,0.6 1.1,1.4 1.4,2.2 0.4,0.9 0.6,1.9 0.5,2.8 z m -2.6,0 c 0,-0.7 -0.1,-1.4 -0.3,-2 -0.2,-0.6 -0.5,-1.1 -0.9,-1.5 -0.4,-0.4 -0.8,-0.8 -1.4,-1 -0.6,-0.2 -1.2,-0.3 -1.8,-0.3 h -2.7 v 9.7 h 2.7 c 0.6,0 1.2,-0.1 1.8,-0.3 0.5,-0.2 1,-0.6 1.4,-1 0.4,-0.4 0.7,-1 0.9,-1.5 0.2,-0.7 0.3,-1.4 0.3,-2.1 z m 8.3,6.9 v -13.8 h 4.8 c 0.8,0 1.6,0.1 2.3,0.3 0.6,0.1 1.1,0.4 1.6,0.7 a 2.73,2.73 0 0 1 0.9,1.2 c 0.2,0.5 0.3,1 0.3,1.5 0,0.3 0,0.6 -0.1,0.9 -0.1,0.3 -0.3,0.6 -0.5,0.8 -0.2,0.3 -0.5,0.5 -0.8,0.7 -0.3,0.2 -0.7,0.4 -1.1,0.5 1.9,0.4 2.8,1.4 2.8,3.1 0,0.6 -0.1,1.1 -0.3,1.6 -0.2,0.5 -0.6,0.9 -1,1.3 -0.5,0.4 -1,0.7 -1.6,0.9 -0.7,0.2 -1.4,0.3 -2.1,0.3 z m 2.6,-7.8 h 2.1 c 0.7,0 1.4,-0.1 2,-0.5 0.5,-0.4 0.7,-0.9 0.7,-1.5 a 1.62,1.62 0 0 0 -0.6,-1.5 c -0.6,-0.3 -1.2,-0.5 -1.9,-0.5 h -2.2 z m 0,1.8 v 4 h 2.6 c 0.4,0 0.8,0 1.2,-0.2 0.3,-0.1 0.6,-0.3 0.8,-0.5 0.2,-0.2 0.3,-0.4 0.4,-0.7 0.1,-0.3 0.1,-0.5 0.1,-0.8 0,-0.3 0,-0.5 -0.1,-0.8 -0.1,-0.2 -0.2,-0.5 -0.5,-0.6 -0.2,-0.2 -0.5,-0.3 -0.8,-0.4 -0.4,-0.1 -0.8,-0.1 -1.2,-0.1 z m 16,0.7 v 5.4 h -2.6 v -5.4 l -5,-8.4 h 2.3 c 0.2,0 0.4,0 0.5,0.2 0.1,0.1 0.2,0.3 0.3,0.4 l 2.5,4.6 c 0.1,0.3 0.3,0.5 0.4,0.8 0.1,0.2 0.2,0.5 0.3,0.7 0.1,-0.3 0.2,-0.5 0.3,-0.7 0.1,-0.2 0.2,-0.5 0.4,-0.8 l 2.5,-4.6 c 0.1,-0.1 0.2,-0.3 0.3,-0.4 0.2,-0.1 0.3,-0.2 0.5,-0.2 h 2.3 z",
    fill: "#ffffff",
    id: "path142"
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs146"
  }, _colorProfile || (_colorProfile = /*#__PURE__*/React.createElement("colorProfile", {
    name: "Agfa-:-Swop-Standard",
    xlinkHref: "../../../WINDOWS/system32/spool/drivers/color/RSWOP.icm",
    id: "color-profile189120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M 715.3,0 H 813 v 97.4 h -97.7 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "F",
    d: "m 747.2,35.2 v 0 l -1.3,6.4 h 2.5 z m -1,-5.1 h 2.1 l 4,17.6 h -2.5 L 749,43.9 h -3.5 l -0.8,3.7 h -2.5 z"
  })), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    inkscapelabel: "Fade to Black or White",
    id: "filter3366",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0",
    id: "feColorMatrix3364",
    result: "fbSourceGraphic"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix3398"
  })), _feColorMatrix3 || (_feColorMatrix3 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix3400",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0",
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    inkscapelabel: "Fade to Black or White",
    id: "filter3370",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix4 || (_feColorMatrix4 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0",
    id: "feColorMatrix3368",
    result: "fbSourceGraphic"
  })), _feColorMatrix5 || (_feColorMatrix5 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix3402"
  })), _feColorMatrix6 || (_feColorMatrix6 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix3404",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0",
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    inkscapelabel: "Fade to Black or White",
    id: "filter3374",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix7 || (_feColorMatrix7 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0",
    id: "feColorMatrix3372",
    result: "fbSourceGraphic"
  })), _feColorMatrix8 || (_feColorMatrix8 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix3406"
  })), _feColorMatrix9 || (_feColorMatrix9 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix3408",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0",
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    inkscapelabel: "Fade to Black or White",
    id: "filter3378",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feColorMatrix10 || (_feColorMatrix10 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0",
    id: "feColorMatrix3376",
    result: "fbSourceGraphic"
  })), _feColorMatrix11 || (_feColorMatrix11 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix3410"
  })), _feColorMatrix12 || (_feColorMatrix12 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix3412",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0",
    in: "fbSourceGraphic"
  })))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E",
    id: "use148",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "H",
    d: "M 715.3,0 H 813 v 97.4 h -97.7 z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#H",
    id: "use170",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    id: "defs182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M 715.3,0 H 813 v 97.4 h -97.7 z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J",
    id: "use184",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", {
    id: "defs194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M 715.3,0 H 813 v 97.4 h -97.7 z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    id: "use196",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.062c3dca.svg";
export { ForwardRef as ReactComponent };